import React, { useEffect, useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import styles from './settlementDetail.module.scss'
import chapter from '../../static/images/chapter.png';
import underApproval from '../../static/images/underApproval.png';
import Pass from '../../static/images/pass.png';
import NotPass from '../../static/images/notPass.png';
import CenterIcon from '../../static/images/centerIcon.png';
import { Toast, Mask, Input, Button } from 'antd-mobile-v5'
import { ApiCore } from '../../api/index';
import alertCircle from '../../static/images/alertCircle.png';
import settleIcon from '../../static/images/settleIcon.png';
import closeicon from '../../static/images/closeicon.png';
import revoke from '../../static/images/revoke.png';
const api = new ApiCore();


const SettlementDetail = (props: any) => {
    const [data, setData] = useState<any>(null)
    const [filterVisible, setFilterVisible] = useState(false)
    const [subjectNumber, setSubjectNumber] = useState<any>('')
    const [balanceCount, setBalanceCount] = useState(0)

    const [revokeVisible, setRevokeVisible] = useState(false)

    const history: any = useHistory();


    useEffect(() => {
        document.title = '结算申请详情'
        getData()
        getSettlementBalance()
    }, [])


    //获取最大结算量
    const getSettlementBalance = () => {
        let params = {
            approveRecordId: props.match.params.id
        }
        api.getSettlementUpdateBalance(params).then((res: any) => {
            if (res.code == 0) {
                setBalanceCount(res.data)
            }
        })
    }


    const getData = () => {
        let params = {
            approveRecordId: props.match.params.id
        }
        api.getApproveSettlementDetail(params).then((res: any) => {
            if (res.code == 0) {
                setData(res.data)
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
    }

    const closeMask = () => {
        setFilterVisible(false)
        setSubjectNumber('')
    }

    const handleSubmit = () => {
        if (!subjectNumber) {
            Toast.show({
                content: '请输入结算数量',
                duration: 2000
            })
            return false;
        }

        if (subjectNumber > balanceCount) {
            Toast.show({
                content: `当前输入数量大于可申请结算数量，当前剩余可结算数量为 ${balanceCount}`,
                duration: 2000
            })
            return false;
        }


        let params = {
            approveRecordId: props.match.params.id,
            num: subjectNumber
        }

        api.updateSettlementBalance(params).then((res: any) => {
            if (res.code == 0) {
                setSubjectNumber('')
                setFilterVisible(false)
                Toast.show({
                    icon: 'success',
                    content: '修改成功'
                })
                history.goBack()
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
    }


    const handleRevoke = () => {

        let params = {
            approveRecordId: props.match.params.id
        }
        api.rollbackSettlement(params).then((res: any) => {
            if (res.code == 0) {
                Toast.show({
                    icon: 'success',
                    content: '撤销成功'
                })
                history.goBack()
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
    }


    return (
        <>
            <div className={styles.settlementDetail}>
                <div className={styles.detail_head}>
                    <div className={styles.left_head}>
                        <img src={underApproval} alt="" />
                        <span>{data && data.state == '0' ? '审批中' : '审批完成'}</span>
                    </div>
                    <img src={chapter} alt="" />
                </div>
                <div className={styles.statistics}>
                    <div className={styles.statistics_item}>
                        <div className={styles.number}>{data && data.total}</div>
                        <div className={styles.label}>申请数量(例)</div>
                    </div>
                    <div className={`${styles.statistics_item} ${styles.success}`}>
                        <div className={styles.number}>{(data && data.passNum) ? data.passNum : '-'}</div>
                        <div className={styles.label}>通过数量(例)</div>
                    </div>
                    <div className={`${styles.statistics_item} ${styles.error}`}>
                        <div className={styles.number}>{(data && data.rejectNum) ? data.rejectNum : '-'}</div>
                        <div className={styles.label}>未通过数量(例)</div>
                    </div>
                </div>

                <div className={styles.title}>
                    <div className={styles.label}>审批明细</div>
                    <div className={styles.pName}>{data && data.projectName}</div>
                </div>

                <div className={styles.centerList}>
                    {
                        data && data.subjectVoList && data.subjectVoList.map((item: any, index: number) => (
                            <div className={styles.centerItem} key={index}>
                                <img className={styles.center_icon} src={CenterIcon} alt="" />
                                <div className={styles.center_info}>
                                    <div className={styles.center_code}>{item.subjectCode}</div>
                                    <div className={styles.center_name}>{item.centerName}</div>
                                </div>
                                {
                                    data.state == '1' ?
                                        <img className={item.settlementState == '2' ? styles.center_pass : styles.center_noPass} src={item.settlementState == '2' ? Pass : NotPass} alt="" />
                                        : <div className={styles.center_empty}></div>
                                }
                            </div>
                        ))
                    }
                </div>

                <div className={styles.fixBottom}>
                    <Button color='primary' className={styles.btn_warp} onClick={() => setFilterVisible(true)}>
                        修改申请数量
                    </Button>
                    <Button color='primary' className={styles.btn_warp} onClick={() => setRevokeVisible(true)}>
                        撤销
                    </Button>
                </div>
            </div>
            <Mask visible={filterVisible} >
                <div className={styles.filterMask}>
                    <div className={styles.content}>
                        <div className={styles.head}>
                            <div className={styles.left}>
                                <img className={styles.icon_check} src={settleIcon} alt="" />
                                <span>请修改您的结算数量</span>
                            </div>
                            <img className={styles.close} src={closeicon} alt="" onClick={closeMask} />
                        </div>
                        <div className={styles.input_number}>
                            <Input
                                placeholder='请输入数量'
                                style={{ '--font-size': '14px' }}
                                type='number'
                                value={subjectNumber}
                                max={184}
                                onChange={val => {
                                    setSubjectNumber(val)
                                }}
                            />
                            <span>例</span>
                        </div>
                        <div className={styles.tips}>
                            <div className={styles.tipItem}>
                                <img src={alertCircle} alt="" />
                                当前可申请数量{balanceCount}例
                            </div>
                            <div className={styles.tipItem}>
                                <img src={alertCircle} alt="" />
                                单次最大结算数量184例
                            </div>
                        </div>
                        <div className={styles.submitbtn}>
                            <Button color='primary' onClick={handleSubmit} className={styles.btn}>
                                确认
                            </Button>
                        </div>
                    </div>
                </div>

            </Mask>


            <Mask visible={revokeVisible} >
                <div className={styles.revokeMask}>
                    <div className={styles.content}>
                        <img src={revoke} alt="" />
                        <div className={styles.tip}>
                            您是否确定撤销当前申请？
                        </div>
                        <div className={styles.btn_warp}>
                            <Button className={styles.btn} onClick={() => setRevokeVisible(false)}>
                                取消
                            </Button>
                            <Button color='primary' onClick={handleRevoke} className={styles.btn_primary}>
                                确认
                            </Button>
                        </div>
                    </div>
                </div>

            </Mask>
        </>
    )
}


export default withRouter(SettlementDetail);